// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ARTICLE_IS_DRAFT = "(Tento \u010dl\u00e1nok je aktu\u00e1lne rozp\u00edsan\u00fd)";
export const ARTICLE_TEXT = "Znenie \u010dl\u00e1nku";
export const ARTICLE_TITLE = "Nadpis \u010dl\u00e1nku";
export const HOWTO_IS_DRAFT = "(Tento n\u00e1vod je aktu\u00e1lne rozp\u00edsan\u00fd, nie publikovan\u00fd)";
export const HOWTO_TEXT = "Kroky n\u00e1vodu";
export const HOWTO_TITLE = "Nadpis n\u00e1vodu";
export const RECIPE_IS_DRAFT = "(Tento recept je aktu\u00e1lne rozp\u00edsan\u00fd, nie publikovan\u00fd)";
export const RECIPE_TEXT = "Postup pr\u00edpravy";
export const RECIPE_TITLE = "Nadpis receptu";
export const TAB_BLOGS_ALL = "V\u0161etky";
export const TAB_BLOGS_POPULAR = "Popul\u00e1rne";
export const TAB_BLOGS_SUBSCRIBED = "Odober\u00e1m";
